var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCollectionsEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B8B7B7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.322 56.604h-4.065l-1.44-1.39c5.042-5.866 8.078-13.482 8.078-21.766C66.895 14.974 51.921 0 33.448 0 14.974 0 0 14.974 0 33.448 0 51.92 14.974 66.895 33.448 66.895c8.284 0 15.9-3.036 21.766-8.079l1.39 1.441v4.065L82.333 90 90 82.333l-25.678-25.73Zm-30.874 0c-12.813 0-23.156-10.343-23.156-23.156 0-12.813 10.343-23.156 23.156-23.156 12.813 0 23.156 10.343 23.156 23.156 0 12.813-10.343 23.156-23.156 23.156Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.464 41.966c-.453-.372-1.252-.669-2.399-.89H19v-17.77h1.75v15.75h8.807c1.003.24 1.6.574 2.577 1.899.977 1.325.733 2.418.866 3.351-.57-1.188-1.083-1.968-1.536-2.34Zm-2.24-18.66c.847.259 1.522.547 2.027.865l-.001 13.58a9.422 9.422 0 0 0-1.286-.397l-.2-.048H22.5l-.001-14h6.726Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.525 21c.57 0 1.235.595 1.515.896.288.31.793 1.03.793 1.625v14.583c-.517-.293-1.16-.522-1.932-.702l-.286-.033h-7.582V21ZM47 23.306v17.77H36.935c-1.147.221-1.946.518-2.4.89-.452.372-.964 1.152-1.535 2.34V26.67c.327-.966.75-1.68 1.27-2.142.519-.463 1.354-.87 2.505-1.22h.891v9.333l3.706-3.5 3.295 3.5-.001-9.334H47Zm-3.501 0 .001 5.566-1.208-1.362a1.206 1.206 0 0 0-1.778-.055l-1.68 1.685-.001-5.834h4.666Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCollectionsEmpty);
export default __webpack_public_path__ + "static/media/ic-collections-empty.073a42ba584fe064b76f1f74bb25cbbe.svg";
export { ForwardRef as ReactComponent };